import { render, staticRenderFns } from "./EventoAdjuntosAdmin.vue?vue&type=template&id=a91efa18&"
import script from "./EventoAdjuntosAdmin.vue?vue&type=script&lang=js&"
export * from "./EventoAdjuntosAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports